<img [src]="selectedBuildingCoverImageUrl()"/>
<chapps-select-input [items]="buildingOptions()"
                     [clearable]="clearable"
                     [loading]="activity.isBusy"
                     [control]="selectionField"
                     [placeholder]="Localization.AllBuildings"></chapps-select-input>
<div class="details">
  <i class="fa fa-hashtag"></i>
  {{ selectedBuildingReference() }}
</div>
